import React from "react";

function PlayerDetails(props) {
  return (
    <div className="music-player--details">
      <div className="range"></div>
      <div className="artist-info">
        <h3 className="details-title">{props.song.name}</h3>
        <h4 className="details-artist">{props.song.singer}</h4>
        <div className="line"></div>
      </div>
    </div>
  );
}

export default PlayerDetails;